<div class="patient-label" *ngIf="patient">
  <div class="label-clinic">{{ safe(patient.clinicName) || 'Clinic' }}</div>
  <div class="label-name">{{ fullName }}</div>
  <div class="label-row">DOB: {{ safe(patient.dob) }}</div>
  <div class="label-row">Patient ID: {{ safe(patient.patientId || patient.accountNumber) }}</div>
  <div class="label-row">Visit: {{ safe(patient.visitDate) }}</div>
  <div class="label-row">Doctor: {{ safe(patient.doctorName) }}</div>
  <div class="label-barcode-wrap" *ngIf="barcodeValue">
    <svg #barcodeEl class="label-barcode-svg"></svg>
  </div>
</div>
